import type { UnitCategory } from "verdi-common/Configurations/SensorConfigurations/SensorConfigurationTypes";
import type { Unit } from "verdi-common/Configurations/Units/UnitConfigurations";
import type { StateCreator } from "zustand";

export interface UnitOverridesSlice {
    unitOverrides: Partial<Record<UnitCategory, Unit>>;
    setUnitOverride: (category: UnitCategory, unit: Unit) => void;
}

export const createUnitOverridesSlice: StateCreator<UnitOverridesSlice, [], [], UnitOverridesSlice> = (set) => ({
    unitOverrides: {},
    setUnitOverride: (category, unit) =>
        set((state) => ({ unitOverrides: { ...state.unitOverrides, [category]: unit } })),
});
